import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=c0cb29fe&scoped=true&"
import script from "./Pricing.vue?vue&type=script&lang=ts&"
export * from "./Pricing.vue?vue&type=script&lang=ts&"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=c0cb29fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cb29fe",
  null
  
)

export default component.exports